import React from 'react';

import DrivingIcon from '@/components/icons/Driving.svg';
import ParkingIcon from '@/components/icons/Parking.svg';
import PublicTransportIcon from '@/components/icons/PublicTransport.svg';

import css from './Transportation.module.css';

const sections: {
  name: string;
  label: string;
  icon?: JSX.Element;
}[] = [
  { name: 'driving', label: 'Driving', icon: <DrivingIcon /> },
  { name: 'parking', label: 'Parking', icon: <ParkingIcon /> },
  {
    name: 'public_transport',
    label: 'Public Transportation',
    icon: <PublicTransportIcon />,
  },
];

const Transportation = (props: { transportation: Record<string, string> }) => {
  const { transportation } = props;
  return (
    <div>
      <h2 className="mb-4 highlight autoType800">Transportation</h2>
      {Object.keys(transportation).map(sectionKey => {
        const sectionContent = transportation[sectionKey];
        const section = sections.find(section => section.name == sectionKey);
        return (
          <div key={sectionKey}>
            <h3 className={css.sectionTitle}>
              <div className={css.sectionIcon}>{section?.icon}</div>
              <span>{section?.label}</span>
            </h3>
            {sectionContent && <div dangerouslySetInnerHTML={{ __html: sectionContent }} />}
          </div>
        );
      })}
    </div>
  );
};

export default Transportation;
